import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { cmsApi } from '../constants/constants'

@Injectable({
  providedIn: 'root'
})
export class LearningService {

  constructor(private http: HttpClient) { }

  getLearningListBySearch(isActive, search) {
    let Url = cmsApi + '/get_LearningListBySearch'
    let Body = { isActive: isActive, search: search }
    // console.log(Url, Body);
    return
  }

  getLearningByID(learningid) {
    const URL = cmsApi + '/get_LearningById';
    const body = { learningid: learningid };

    return this.http.post(URL, body);
  }

  getLearning() {
    const URL = cmsApi + '/get_LearningList_front';
    return this.http.post(URL, "");
  }


}
